module.exports = __webpack_public_path__ + "static/media/linkedin.75501cc0.png";